<p-toast position="bottom-right"></p-toast>
<div class="card m-1">
  <p-breadcrumb [model]="breadItems"></p-breadcrumb>
</div>
<div class="card m-1">
  <div class="card-header bg-gradient-gray-dark text-orange">
    <i class="nav-icon fas fa-chart-line"></i>
    <strong> Changes Logs of  :: {{lineName}} </strong>
  </div>
  <div class="card-body">
    <div *ngIf="!notExist" class="row">
      <div class="field  col-2">
        <label class="block" style="width:100%">&nbsp;</label>
        <p-button label="Week" icon="pi pi-palette" iconPos="left"
                  [style]="{'width':'45%'}" (onClick)="drawWeek()"></p-button>&nbsp;
        <p-button label="Month" icon="pi pi-palette" iconPos="left"
                  [style]="{'width':'45%'}" (onClick)="drawMonth()"></p-button>
      </div>
      <div class="field col-3">
        <label class="block">From</label>
        <p-calendar [(ngModel)]="fromDate" [showTime]="true" baseZIndex="100" [style]="{'width':'100%'}" appendTo="body" showClear="true"
                    [minDate]="minSelectableDate" [maxDate]="maxSelectableDate"></p-calendar>
      </div>
      <div class="field col-3">
        <label class="block">To</label>
        <p-calendar [(ngModel)]="toDate" [showTime]="true" [style]="{'width':'100%'}" appendTo="body" showClear="true"
                    [minDate]="minSelectableDate" [maxDate]="maxSelectableDate"></p-calendar>
      </div>
      <div class="field  col-2">
        <label class="block">&nbsp;</label>
        <p-button label="Draw" icon="pi pi-palette" iconPos="left"
                  [style]="{'width':'100%'}" (onClick)="getDevicePingChangesLogById()"></p-button>
      </div>

    </div>

   
      <div *ngIf="!notExist"  id="status-chart"></div>


      <img *ngIf="notExist" src="../../../../assets/error404.jpg" />

  </div>
  </div>
